export default "__VITE_ASSET__Cubqs9oM__"